<template lang="html">
  <div>
    <page-row title="Variant" :margin="2">
      <div class="uk-button-group">
        <button class="uk-button uk-button-small uk-button-primary" @click="openModal(0)">Simple</button>
        <button class="uk-button uk-button-small uk-button-primary" @click="openModal(1)">Long content</button>
        <button class="uk-button uk-button-small uk-button-primary" @click="openModal(2)">Scroll</button>
        <button class="uk-button uk-button-small uk-button-primary" @click="openModal(3)">Fullscreen</button>
        <button class="uk-button uk-button-small uk-button-primary" @click="openModal(20)">Scroll & Fullscreen</button>
      </div>
    </page-row> 

    <page-row :margin="2" title="Position">
      <div>
        <div class="row">
          <div class="uk-button-group">
            <button class="uk-button uk-button-small uk-button-primary" @click="openModal(7)">top left</button>
            <button class="uk-button uk-button-small uk-button-primary" @click="openModal(8)">top</button>
            <button class="uk-button uk-button-small uk-button-primary" @click="openModal(9)">top right</button>
          </div>
        </div>

        <div class="row">
          <div class="uk-button-group">
            <button class="uk-button uk-button-small uk-button-primary" @click="openModal(4)">left center</button>
            <button class="uk-button uk-button-small uk-button-primary" @click="openModal(5)">center</button>
            <button class="uk-button uk-button-small uk-button-primary" @click="openModal(6)">right center</button>
          </div>
        </div>

        <div class="row">
          <div class="uk-button-group">
            <button class="uk-button uk-button-small uk-button-primary" @click="openModal(10)">bottom left</button>
            <button class="uk-button uk-button-small uk-button-primary" @click="openModal(11)">bottom</button>
            <button class="uk-button uk-button-small uk-button-primary" @click="openModal(12)">bottom right</button>
          </div>
        </div>
      </div>
      
    </page-row>

    <page-row title="Scroll with left/right position" :margin="2">
      <div class="uk-button-group">
        <button class="uk-button uk-button-primary uk-button-small" @click="openModal(13)">Left</button>
        <button class="uk-button uk-button-primary uk-button-small" @click="openModal(14)">Right</button>
      </div>
    </page-row> 

     <page-row title="Header and footer slots" :margin="2">
      <div class="uk-button-group">
        <button class="uk-button uk-button-small uk-button-primary" @click="openModal(15)">Header</button>
        <button class="uk-button uk-button-small uk-button-primary" @click="openModal(16)">Footer</button>
        <button class="uk-button uk-button-small uk-button-primary" @click="openModal(17)">Header & Footer</button>
      </div>
    </page-row> 

     <page-row title="Callback" :margin="2">
      <div class="uk-button-group">
        <button class="uk-button uk-button-primary uk-button-small" @click="openModal(18)">onDismiss</button>
        <button class="uk-button uk-button-primary uk-button-small" @click="openModal(19)">onClose</button>
      </div>
    </page-row> 

     <page-row title="Other" :margin="2">
      <div class="uk-button-group">
        <button class="uk-button uk-button-primary uk-button-small" @click="openModal(21)">Multi modals</button>
        <button class="uk-button uk-button-primary uk-button-small" @click="openModal(22)">Escapable</button>
        <button class="uk-button uk-button-primary uk-button-small" @click="openModal(23)">Without dismiss by pressing the mask</button>
      </div>
    </page-row> 

  </div>
</template>

<script>
import Content from '@/examples/modals/content'
import vModal from '@/examples/modals/vmodal'
import { Bus } from 'src'
export default {
  name: 'examples-page',
  data() {
    const modals = [
      {
        title: 'Simple modal',
        component: Content,
      },
      {
        title: 'Long modal',
        component: Content,
        props: {
          lorem: true
        }
      },
      {
        title: 'Scroll modal',
        component: Content,
        isScroll: true,
        props: {
          lorem: true
        }
      },
      {
        title: 'Fullscreen modal',
        component: Content,
        fullscreen: true,
        props: {
          lorem: true
        }
      },
      {
        title: 'Left center position modal',
        component: Content,
        isLeft: true,
        center: true
      },
      {
        title: 'Center modal',
        component: Content,
        center: true
      },
      {
        title: 'Right center position modal',
        component: Content,
        isRight: true,
        center: true
      },
      {
        title: 'Top left position modal',
        component: Content,
        isTop: true,
        isLeft: true
      },
      {
        title: 'Top position modal',
        component: Content,
        isTop: true
      },
      {
        title: 'Top right position modal',
        component: Content,
        isTop: true,
        isRight: true
      },
      {
        title: 'Bottom left position modal',
        component: Content,
        isBottom: true,
        isLeft: true
      },
      {
        title: 'Bottom position modal',
        component: Content,
        isBottom: true
      },
      {
        title: 'Bottom right position modal',
        component: Content,
        isBottom: true,
        isRight: true
      },
      {
        title: 'Scroll left modal',
        component: Content,
        isScroll: true,
        isLeft: true,
        props: {
          lorem: true
        }
      },
      {
        title: 'Scroll right modal',
        component: Content,
        isScroll: true,
        isRight: true,
        props: {
          lorem: true
        }
      },
      {
        title: 'Custom header slot',
        component: vModal,
        props: {
          header: true
        }
      },
      {
        title: 'Custom footer slot',
        component: vModal,
        props: {
          footer: true
        }
      },
      {
        title: 'Custom header and footer slot',
        component: vModal,
        props: {
          header: true,
          footer: true
        }
      },
      {
        title: 'Callback onDismiss',
        component: vModal,
        props: {
          footer: true
        },
        onDismiss() {
          alert('onDismiss callback call!')
        }
      },
      {
        title: 'Callback onClose',
        component: vModal,
        props: {
          footer: true,
          closeCallback: true
        },
        onClose() {
          alert('onClose callback call!')
        }
      },
      {
        title: 'Fullscreen & Scroll modal',
        component: Content,
        fullscreen: true,
        isScroll: true,
        props: {
          lorem: true
        }
      },
      {
        title: 'Multi modal',
        component: Content,
        props: {
          modal: true
        }
      },
      {
        title: 'Escapable modal',
        component: Content,
        escapable: true,
        center: true,
        props: {
          escape: true
        }
      },
      {
        title: 'Without dismiss by pressing the mask',
        component: Content,
        escapable: true,
        center: true,
        dismissable: false,
        props: {
          escape: true,
          dismiss: false
        }
      },
    ]
    return {
      modals
    }
  },
  created() {
    // Bus.$on('new', options => {
    //   console.dir(options)
    // })
    // Bus.$on('opened', options => {
    //   console.dir(options)
    // })
    // this.$modals.$on('modals:opened', data => {
    //   console.log('opened ', data)
    // });
  },
  methods: {
    openModal(index) {
      this.$modals.open(this.modals[index])
      // this.$emit('modals:new', this.modals[index])
      // this.$modals.$emit('new', this.modals[index])
      // Bus.$emit('new', this.modals[index])
    }
  }
};
</script>


// WEBPACK FOOTER //
// examples.vue?20a8500f